// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as TestUtils$OrcaPaymentPage from "./Utilities/TestUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./Utilities/PaymentBody.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "./Payments/VaultHelpers.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "./Utilities/PaymentHelpersV2.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "./Components/PaymentInputField.bs.js";
import * as PaymentManagementBody$OrcaPaymentPage from "./Utilities/PaymentManagementBody.bs.js";
import * as SubscriptionEventHooks$OrcaPaymentPage from "./Hooks/SubscriptionEventHooks.bs.js";

function CardCVCElement(props) {
  let __savedCardBrand = props.savedCardBrand;
  let __isVaultCvcFlow = props.isVaultCvcFlow;
  let __isSavedCardCvcFlow = props.isSavedCardCvcFlow;
  let paymentType = props.paymentType;
  let cvcProps = props.cvcProps;
  let __isSavedCardCvcFlow_value = __isSavedCardCvcFlow !== undefined ? __isSavedCardCvcFlow : false;
  let __isVaultCvcFlow_value = __isVaultCvcFlow !== undefined ? __isVaultCvcFlow : false;
  let __savedCardBrand_value = __savedCardBrand !== undefined ? __savedCardBrand : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let emitter = SubscriptionEventHooks$OrcaPaymentPage.useSubscriptionEventEmitter();
  let match$1 = match.config.appearance;
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  let vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let setCvcError = cvcProps.setCvcError;
  let cvcError = cvcProps.cvcError;
  let cvcRef = cvcProps.cvcRef;
  let cvcNumber = cvcProps.cvcNumber;
  let isCVCValid = cvcProps.isCVCValid;
  let savedCardBrand = CardUtils$OrcaPaymentPage.normalizeCardBrand(__savedCardBrand_value);
  let isCvcEmpty = cvcNumber === "";
  let isCvcComplete = __isSavedCardCvcFlow_value ? CardUtils$OrcaPaymentPage.checkCardCVC(cvcNumber, savedCardBrand) : cvcNumber.length >= 3;
  let maxCvcLength = __isSavedCardCvcFlow_value ? CardValidations$OrcaPaymentPage.getobjFromCardPattern(savedCardBrand).maxCVCLength : 4;
  let compressedLayoutStyleForCvcError = !__isSavedCardCvcFlow_value && match$1.innerLayout === "Compressed" && cvcError.length > 0 ? "!border-l-0" : "";
  let submitCallback = React.useCallback(ev => {
    if (__isSavedCardCvcFlow_value) {
      let confirmDict = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(ev.data));
      let confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(confirmDict);
      let isOuterValid = Utils$OrcaPaymentPage.getBool(confirmDict, "isOuterValid", true);
      if (!confirm.doSubmit) {
        return;
      }
      let isCvcValid = Core__Option.getOr(isCVCValid, false);
      if (isCvcValid && isOuterValid) {
        setCvcError(param => "");
        if (!__isVaultCvcFlow_value) {
          return Utils$OrcaPaymentPage.messageParentWindow(keys.parentURL, [
            [
              "savedCardCvcDataEvent",
              true
            ],
            [
              "cvcNumber",
              cvcNumber
            ]
          ]);
        }
        let match;
        if (typeof vaultCredentials !== "object" || vaultCredentials.TAG !== "HyperswitchVault") {
          match = [
            "",
            ""
          ];
        } else {
          let creds = vaultCredentials._0;
          match = [
            creds.pmSessionId,
            creds.sdkAuthorization
          ];
        }
        Core__Promise.$$catch(PaymentHelpersV2$OrcaPaymentPage.updatePaymentMethod(PaymentManagementBody$OrcaPaymentPage.vaultUpdateCVVBody(cvcNumber), match[0], loggerState, customPodUri, match[1]).then(res => {
          let vaultTokenData = VaultHelpers$OrcaPaymentPage.decodeVaultTokenData(res);
          if (vaultTokenData.token !== "") {
            Utils$OrcaPaymentPage.messageParentWindow(keys.parentURL, [
              [
                "savedCardCvcTokenEvent",
                true
              ],
              [
                "cvcToken",
                vaultTokenData.token
              ]
            ]);
          } else {
            Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
          }
          return Promise.resolve();
        }), param => {
          Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
          return Promise.resolve();
        });
        return;
      }
      if (isCvcValid) {
        return;
      }
      let errorMsg = cvcNumber.length === 0 ? localeString.cvcNumberEmptyText : localeString.inCompleteCVCErrorText;
      setCvcError(param => errorMsg);
      if (isOuterValid) {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", errorMsg);
      } else {
        return;
      }
    }
    let json = Utils$OrcaPaymentPage.safeParse(ev.data);
    try {
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      let confirmParams = dict["requestCVCConfirm"];
      if (confirmParams === undefined) {
        return;
      }
      let confirmParamsDict = Utils$OrcaPaymentPage.getDictFromJson(confirmParams);
      let requiresCvv = Utils$OrcaPaymentPage.getBool(confirmParamsDict, "requiresCvv", true);
      if (paymentType !== "CardCVCElement") {
        return;
      }
      let body = Utils$OrcaPaymentPage.getJsonObjectFromDict(confirmParamsDict, "body");
      let bodyArr = Object.entries(Core__Option.getOr(Core__JSON.Decode.object(body), {}));
      let payload = Utils$OrcaPaymentPage.getJsonFromDict(confirmParamsDict, "payload", null);
      let paymentTypeStr = Utils$OrcaPaymentPage.getString(confirmParamsDict, "paymentType", "card");
      let publishableKeyVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "publishableKey", keys.publishableKey);
      let clientSecretVal = Utils$OrcaPaymentPage.getString(confirmParamsDict, "clientSecret", Core__Option.getOr(keys.clientSecret, ""));
      let isCvcComplete = cvcNumber.length >= 3;
      if (requiresCvv && isCvcComplete) {
        setCvcError(param => "");
        let bodyWithCvc = bodyArr.concat([PaymentBody$OrcaPaymentPage.cardTokenCvcTuple(cvcNumber)]);
        let paymentType$1 = PaymentHelpers$OrcaPaymentPage.getPaymentType(paymentTypeStr);
        Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.paymentIntentForPaymentSession(bodyWithCvc, paymentType$1, payload, publishableKeyVal, clientSecretVal, loggerState, customPodUri, redirectionFlags, undefined, Primitive_option.some(keys.sdkAuthorization), "CardCVCElement").then(response => {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
              "cvcWidgetConfirmResponse",
              response
            ]]);
          return Promise.resolve();
        }), err => {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
              "cvcWidgetConfirmErrorResponse",
              JSON.stringify(Utils$OrcaPaymentPage.formatException(err))
            ]]);
          return Promise.resolve();
        });
        return;
      }
      if (!requiresCvv) {
        return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
            "cvcWidgetConfirmErrorResponse",
            Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
          ]]);
      }
      let isEmptyCVC = cvcNumber.length === 0;
      let errorMsg$1 = isEmptyCVC ? localeString.cvcNumberEmptyText : localeString.inCompleteCVCErrorText;
      setCvcError(param => errorMsg$1);
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "cvcWidgetConfirmErrorResponse",
          Utils$OrcaPaymentPage.handleFailureResponse(errorMsg$1, "cvc_validation_failed")
        ]]);
    } catch (exn) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "cvcWidgetConfirmErrorResponse",
          Utils$OrcaPaymentPage.handleFailureResponse("Something went wrong", "cvc_validation_failed")
        ]]);
    }
  }, [
    __isSavedCardCvcFlow_value,
    __isVaultCvcFlow_value,
    isCVCValid,
    cvcNumber,
    keys,
    paymentType,
    loggerState,
    customPodUri,
    redirectionFlags,
    localeString,
    vaultCredentials
  ]);
  Utils$OrcaPaymentPage.useSubmitPaymentDataFromParent(keys.parentURL, submitCallback);
  React.useEffect(() => {
    SubscriptionEventHooks$OrcaPaymentPage.emitReady(keys.iframeId, CardThemeType$OrcaPaymentPage.getPaymentModeToString(paymentType));
  }, [
    keys.iframeId,
    paymentType
  ]);
  React.useEffect(() => {
    if (!__isSavedCardCvcFlow_value) {
      let cvcInfoDict = Object.fromEntries([[
          "isCvcEmpty",
          isCvcEmpty
        ]]);
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "cvcInfo",
          cvcInfoDict
        ]]);
    }
  }, [isCvcEmpty]);
  React.useEffect(() => {
    if (__isSavedCardCvcFlow_value) {
      let status = Object.fromEntries([
        [
          "empty",
          isCvcEmpty
        ],
        [
          "complete",
          Core__Option.getOr(isCVCValid, false)
        ],
        [
          "valid",
          Core__Option.getOr(isCVCValid, false)
        ],
        [
          "error",
          cvcError
        ]
      ]);
      Utils$OrcaPaymentPage.messageParentWindow(keys.parentURL, [[
          "savedCardCvcStatus",
          status
        ]]);
    }
  }, [
    __isSavedCardCvcFlow_value,
    isCvcEmpty,
    isCvcComplete,
    isCVCValid,
    cvcError,
    keys.parentURL
  ]);
  React.useEffect(() => {
    if (!__isSavedCardCvcFlow_value) {
      emitter.emitCvcStatus(keys.iframeId, isCvcEmpty, isCvcComplete);
    }
  }, [
    __isSavedCardCvcFlow_value,
    isCvcEmpty,
    isCvcComplete,
    keys.iframeId
  ]);
  React.useEffect(() => {
    if (__isSavedCardCvcFlow_value) {
      Core__Option.forEach(Primitive_option.fromNullable(cvcRef.current), input => {
        input.focus();
      });
    }
  }, [__isSavedCardCvcFlow_value]);
  return JsxRuntime.jsx(PaymentInputField$OrcaPaymentPage.make, {
    isValid: Primitive_option.some(isCVCValid),
    setIsValid: cvcProps.setIsCVCValid,
    height: __isSavedCardCvcFlow_value ? "1.8rem" : "",
    value: cvcNumber,
    onChange: cvcProps.changeCVCNumber,
    onBlur: cvcProps.handleCVCBlur,
    errorString: __isSavedCardCvcFlow_value ? "" : cvcError,
    fieldName: __isSavedCardCvcFlow_value ? "" : localeString.cvcTextLabel,
    id: __isSavedCardCvcFlow_value ? undefined : "card-cvc",
    name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
    type_: "tel",
    maxLength: maxCvcLength,
    placeholder: "123",
    className: `tracking-widest w-full ` + compressedLayoutStyleForCvcError,
    inputRef: cvcRef,
    autocomplete: "cc-csc"
  });
}

let make = CardCVCElement;

export {
  make,
}
/* jotai Not a pure module */
